import React from "react";

import { cx } from "../../utils/functions";
import { Badge } from "../ui/Badge";
import { ReportBugButton } from "../ReportBugButton";
import { Link } from "react-router-dom";

interface PageHeaderProps {
  pageTitle: string;
  children?: React.JSX.Element;
  labTypeSubscriptions?: string[];
  backButton?: React.JSX.Element;
  organisationName?: string;
  adminGuidePath?: string;
  userGuidePath?: string;
}

const LABTYPE_LABEL = {
  wet: "Wet Lab",
  dry: "Dry Lab",
};

export const PageHeader = ({
  labTypeSubscriptions,
  pageTitle,
  children,
  backButton,
  organisationName,
  adminGuidePath,
  userGuidePath,
}: PageHeaderProps) => {
  return (
    <div className="bg-amber-50 rounded-lg shadow-md p-4 sm:p-6 border-2 border-solid border-[#eaddc9]">
      <div className="w-full">
        <div className="w-full">
          <div className={cx(
            children && "mb-4 sm:mb-8"
          )}>
            <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-4">
              <div className="flex-1 min-w-0">
                <h1 className="text-2xl sm:text-3xl font-bold mb-1 sm:mb-0 break-words">
                  {pageTitle}
                </h1>
                {organisationName && (
                  <h4 className="text-sm sm:text-base font-semibold text-gray-700 mt-1">
                    Organisation: {organisationName}
                  </h4>
                )}
              </div>

              {(adminGuidePath || userGuidePath || backButton) && (
                <div className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-2 sm:gap-3 mt-2 lg:mt-0 w-full lg:w-auto">
                  <ReportBugButton pageName={pageTitle} className="flex-shrink-0 w-full sm:w-auto" />
                  {adminGuidePath && (
                    <Link
                      to={adminGuidePath}
                      className="btn btn-outline btn-sm p-5 flex-shrink-0 w-full sm:w-auto"
                    >
                      <span className="hidden sm:inline">View Admin Guide</span>
                      <span className="inline sm:hidden">Admin Guide</span>
                    </Link>
                  )}
                  {userGuidePath && (
                    <Link
                      to={userGuidePath}
                      className="btn btn-outline btn-sm p-5 flex-shrink-0 w-full sm:w-auto"
                    >
                      <span className="hidden sm:inline">View User Guide</span>
                      <span className="inline sm:hidden">User Guide</span>
                    </Link>
                  )}
                  {backButton && (
                    <div className="flex-shrink-0 w-full sm:w-auto">
                      {backButton}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {children}

          {labTypeSubscriptions && labTypeSubscriptions.length > 0 && (
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 mt-4 sm:mt-6">
              <h4 className="text-sm sm:text-base font-medium text-gray-700">
                Subscribed platforms:
              </h4>
              <div className="flex flex-wrap gap-2">
                {labTypeSubscriptions.map((labTypeSubscription: string, index) => {
                  if (!["wet", "dry"].includes(labTypeSubscription)) {
                    return null;
                  }
                  const label = LABTYPE_LABEL[labTypeSubscription as keyof typeof LABTYPE_LABEL];
                  return (
                    <Badge
                      key={`${labTypeSubscription}-${index}`}
                      variant='primary'
                      className="whitespace-nowrap"
                    >
                      {label}
                    </Badge>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
